import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import { withFormik } from 'formik';

import PropTypes from 'prop-types';

import BackgroundImage from '../../images/background.png';
import * as Yup from 'yup';


import {
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';

import {
  InputBlack,
  PrimaryButton,
  LoginH1,
  FormWrapper
} from '../../components/HelperComponents/StyledComponents';

import { signInAction } from '../../actions/UserActions';

// Our inner form component which receives our form's state and updater methods as props
export const InnerForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting
}) => (
  <FormWrapper onSubmit={handleSubmit}>
    <section className="field">
      <div className="control">
        <InputBlack
          className="input is-transparent is-rounded"
          type="text"
          name="username"
          placeholder="Username or Email Address"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.username}
        />
        {touched.username && errors.username && <p className="help is-danger">{errors.username}</p>}
      </div>
    </section>
    <section className="field">
      <div className="control" >
        <InputBlack
          className="input is-transparent is-rounded"
          placeholder="Password"
          type="password"
          name="password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
        />
        {touched.password && errors.password && <p className="help is-danger">{errors.password}</p>}
      </div>
      <div className="field" style={{margin: '.5rem 0'}}>
        <div className="control">
          <p className="has-text-right">
            <Link to="/forgot-password" className="has-text-white">Forgot password?</Link>
          </p>
        </div>
      </div>
    </section>

    <PrimaryButton className="button is-rounded" style={{ width: '100%'}} type="submit" disabled={isSubmitting}>Log In</PrimaryButton>
  </FormWrapper>
);

InnerForm.propTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
  touched: PropTypes.any,
  isSubmitting: PropTypes.any
};

class LoginComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    user: PropTypes.object
  }

  static defaultProps = {
    user: {

    }
  }

  handleLogin = (values, { _props, setSubmitting, _setErrors}) => {
    this.props.dispatch(signInAction({ username: values.username, password: values.password }, this.props.history));

    setSubmitting(false);
  }
  
  render() {
    // Wrap our form with the using withFormik HoC
    const MyForm = withFormik({
      validationSchema: Yup.object({
        username: Yup.string().required('Username or Email Address is required'),
        password: Yup.string().required('Password is required'),
      }),
      // Transform outer props into form values
      mapPropsToValues: _props => ({ username: '', password: '' }),
      // Submission handler
      handleSubmit: this.handleLogin,
    })(InnerForm);

    const FormStructure = () => (
      <section className="container">
        <section className="columns is-centered">
          <section className="column is-4">
            <LoginH1>Log In</LoginH1>
            <MyForm>
            </MyForm>
            <p className="help is-danger">
              {this.props.user.error}
            </p>
          </section>
        </section>
      </section>
    );

    return (
      <Fragment>
        <BulmaHero heroSize="is-fullheight" activateBodyPadding={true} body={<FormStructure />} image={BackgroundImage}></BulmaHero>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;

  return {
    user
  };
}

export const Login = connect(mapStateToProps)(LoginComponent);


// WEBPACK FOOTER //
// ./src/routes/Login/Login.js